import { ModuleWithProviders, NgModule, Type } from '@angular/core'

import { ClientStoreInterface, NomenclatorServiceInterface } from '@flowx/core-sdk'

import { FlxProcessRendererComponent } from './process-renderer/process-renderer.component'
import {
  FLX_CLIENT_STORE_CONFIG,
  FLX_COMPONENTS_CONFIG,
  FLX_CUSTOM_LOADER_CONFIG,
  FLX_NOMENCLATOR_CONFIG,
  FLX_VALIDATORS_CONFIG,
} from './services/providers'
import { NgSyncValidator } from './utils/validators'

export type CustomLoader = {
  actions?: Record<string, Type<any>>
  startProcess?: Type<any>
  reloadProcess?: Type<any>
  defaultAction?: Type<any>
  defaultUpload?: Type<any>
}

export type FlxConfig = {
  validators?: Record<string, NgSyncValidator>
  components?: Record<string, Type<any>>
  services?: {
    LocalDataStoreService?: Type<ClientStoreInterface>
    NomenclatorService?: Type<NomenclatorServiceInterface>
  }
  customLoader?: CustomLoader
}

@NgModule({
  imports: [FlxProcessRendererComponent],
  exports: [FlxProcessRendererComponent],
})
export class FlxProcessModule {
  static withConfig({
    validators,
    components,
    services,
    customLoader,
  }: FlxConfig): ModuleWithProviders<FlxProcessModule> {
    return {
      ngModule: FlxProcessModule,
      providers: [
        {
          provide: FLX_VALIDATORS_CONFIG,
          useValue: validators,
        },
        {
          provide: FLX_COMPONENTS_CONFIG,
          useValue: components,
        },
        {
          provide: FLX_CUSTOM_LOADER_CONFIG,
          useValue: customLoader,
        },
        ...(services.LocalDataStoreService
          ? [
              {
                provide: FLX_CLIENT_STORE_CONFIG,
                useExisting: services.LocalDataStoreService,
              },
            ]
          : []),
        ...(services.NomenclatorService
          ? [
              {
                provide: FLX_NOMENCLATOR_CONFIG,
                useExisting: services.NomenclatorService,
              },
            ]
          : []),
      ],
    }
  }
}
